import { render, staticRenderFns } from "./DetailNews.vue?vue&type=template&id=fae20952&scoped=true&"
import script from "./DetailNews.vue?vue&type=script&lang=js&"
export * from "./DetailNews.vue?vue&type=script&lang=js&"
import style0 from "./DetailNews.vue?vue&type=style&index=0&id=fae20952&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fae20952",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ApiContent: require('/opt/build/repo/components/ApiContent.vue').default,SocialPicto: require('/opt/build/repo/components/SocialPicto.vue').default})
